module.exports = __webpack_public_path__ + "img/star.c26f686b.svg";